import * as Types from './types';
import { actionTypes } from './constants';

export const addBeforeWithdrawHook = (hook: Types.TBeforeWithdrawHook):
    Types.IAddBeforeWithdrawHookAction => ({
    type: actionTypes.ADD_BEFORE_WITHDRAW_HOOK,
    payload: hook
});
